var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.whiteNames.includes(_vm.$route.name))?_c('common-header'):_vm._e(),_c('div',{class:!_vm.whiteNames.includes(_vm.$route.name) ? 'main-body' : ''},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }